import React from 'react';
import { ThemedIcon, ControlsTheme } from '@/components/video-player/ui/ThemedIcon';

export type PlayIconTheme = ControlsTheme;

interface ModernPlayIconProps {
  iconType: PlayIconTheme;
  className?: string;
}

export const ModernPlayIcon: React.FC<ModernPlayIconProps> = ({
  iconType,
  className = 'h-full w-full',
}) => {
  // O tema 'safari' (antigo 'custom') não usa mais imagem própria — todos os
  // temas usam o glyph temático do ThemedIcon.
  return <ThemedIcon name="play" theme={iconType} className={className} />;
};
